import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthenticationDataService } from '../../services/authentication-data.service';
import { ApplicationService } from '../../services/application.service';
import { User } from '../../models/user.model';
import { RolesEnum } from '../../enums/roles.enum';
import { takeUntil } from 'rxjs/operators';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [RouterModule, CommonModule, NgbDropdownModule]
})
export class HeaderComponent implements OnInit, OnDestroy {
  public currentUser: User;
  public applicationVersion: string;
  public RolesEnum = RolesEnum;
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private authenticationDataService: AuthenticationDataService,
    private applicationService: ApplicationService
  ) {

  }

  public ngOnInit(): void {
    this.currentUser = this.authenticationService.getAuthorizedUser();
    this.applicationService.getVersionNumber()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((versionNumber: string) => {
        this.applicationVersion = versionNumber;
      });
  }

  public logout(): void {
    this.authenticationService.logout(true);
  }

  public getLogoRedirect(): string {
    if (this.currentUser) {
      if (this.currentUser.Role === RolesEnum.CustomerRole) {
        return '/tracking';
      } else {
        return '/consolidation';
      }
    } else {
      return '/tracker';
    }
  }

  public showMenu(): boolean {
    // return this.currentUser && this.currentUser.Role !== RolesEnum.CustomerRole;
    return !!this.currentUser;
  }

  public showUserManagementMenuItem(): boolean {
    return this.currentUser && this.currentUser.Role === RolesEnum.AdminRole;
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public CleanCache(): boolean {
    sessionStorage.removeItem('MBL');
    sessionStorage.removeItem('HBL');
    sessionStorage.removeItem('Container');
    sessionStorage.removeItem('CustomerRef');
    sessionStorage.removeItem('ShipmentCode');
    sessionStorage.removeItem('ConsigneeName');
    return true;
  }
}

